import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './UserForm.module.scss';
import styles1 from './UploadDocs.module.scss';
import { useDebounce } from '../../hooks';
import { getBusinessData, uploadFiles } from '../../api';
import { CheckingValidComment, isValidEmail, isValidMobileNum } from '../../lib/common';
import { complaintList } from '../../lib/userReport';
import '../../styles/_predefine.scss';

const UserForm = (props) => {
  const { selectedItem, cityList, fields, setFields, fileData, setFileData, handleSubmitClick, haveSubmitted } = props;
  const [cityFilter, setCityFilter] = useState({});
  const [display, setDisplay] = useState({});
  const debouncedSearchText = useDebounce(fields?.companyName?.fvalue, 500);
  const [businessDataRes, setBusinessesData] = useState([]);
  const [disable, setDisabled] = useState(true);

  useEffect(() => {
    const handleGetBusinessData = async () => {
      try {
        if (debouncedSearchText && fields?.companyName?.fvalue && fields?.city?.fvalue) {
          const params = {
            city: fields?.city?.fvalue || '',
            companyName: fields?.companyName?.fvalue || '',
            phone: '',
            parentId: '',
            emailId: '',
            pincode: '',
            page: '',
          };
          const res = await getBusinessData(params, 1);
          if (res) {
            setBusinessesData(res || []);
          }
        } else {
          setBusinessesData([]);
        }
      } catch (err) {
        console.error('Error: ', err);
      }
    };
    handleGetBusinessData();
  }, [debouncedSearchText]);

  const handleOnchange = (item, val) => {
    if (fields[item].type === 'dropdown') {
      setDisplay({ name: fields[item].name, disp: true });
    }
    fields[item].fvalue = val;
    const fObj = fields;
    const filteredCitiesData = Object.fromEntries(
      Object.entries(cityList).filter(([key]) => key.toLowerCase().includes(val.toLowerCase())),
    );
    setCityFilter(filteredCitiesData);
    setFields(fObj);
  };
  const handleDropDownClick = async (item, val, cObj = {}) => {
    if (fields[item].type === 'dropdown') {
      setDisplay({ name: '', disp: false });
    }
    fields[item].fvalue = val;
    if (fields[item].name === 'compname') {
      fields.vendorName.fvalue = cObj?.ownerName;
      fields.vendorNumber.fvalue = cObj?.mobile;
      fields.docid.fvalue = cObj?.docId;
    }

    const fObj = fields;
    setFields(fObj);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const files = event.target.files ? [...event.target.files] : [];
      const tempFileData = [...fileData];
      try {
        // setDisabled(true);
        const response = await uploadFiles(files, true);
        if (response.error_code === 0) {
          if (response.image_urls && response.image_urls.length > 0) {
            tempFileData.push({ name: files[0].name, url: response.image_urls[0] });
            setFileData(tempFileData);
          }
        }
        // setDisabled(false);
      } catch (err) {
        console.log('Error: ', err);
      }
    }
  };

  useEffect(() => {
    const value = Object.keys(fields).filter((x) =>
      x === 'comment'
        ? !CheckingValidComment?.(fields?.comment?.fvalue)
        : ['userNumber', 'vendorNumber'].includes(x)
          ? !isValidMobileNum(fields[x]?.fvalue)
          : x === 'userEmail'
            ? !isValidEmail(fields[x]?.fvalue)
            : !fields[x]?.fvalue,
    );
    if (value && value.length > 0) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [
    fields?.comment?.fvalue,
    fields?.userEmail?.fvalue,
    fields?.userNumber?.fvalue,
    fields?.vendorNumber?.fvalue,
    fields?.city?.fvalue,
    fields?.companyName?.fvalue,
    fields?.complaintType?.fvalue,
    fields?.vendorName?.fvalue,
  ]);

  const errorView = (key, value) => {
    return (
      <div className="font12 fw500 colorEC4 ml-2 mt-6 mb-6">
        {key === 'userEmail' && (value && value.trim().length > 0 && !isValidEmail(value) ? 'Email is not valid' : '')}
        {['complaintType', 'city', 'companyName', 'vendorName'].includes(key) &&
        value?.length > 1 &&
        value.trim() === ''
          ? `${key} cannot be empty`
          : ''}
        {['userNumber', 'vendorNumber'].includes(key) && value && !isValidMobileNum(value)
          ? 'Mobile number is not valid'
          : ''}
        {key === 'upload' ? 'Only 5 attachments can be uploaded.' : ''}
      </div>
    );
  };
  const handleFileDelete = (i) => {
    fileData.splice(i, 1);
    setFileData([...fileData]);
  };

  return (
    <>
      <div className="p-20">
        <div className={`${styles.Form} p-20`}>
          <div className="font14 fw600 color111">
            Please use the form below to let us know about your issue, and we&apos;ll get back to you with the best
            solution
          </div>

          <div className={`${styles.Form__box} mt-5`}>
            {fields &&
              Object.keys(fields).map((item, key) => (
                <React.Fragment key={key}>
                  {fields[item].type !== 'textarea' && fields[item].name !== 'docid' && (
                    <>
                      <div className="form_group_box mt-25">
                        <div className="form_group">
                          <input
                            className="input font12 fw500 color111 pl-10 pr-45"
                            type="text"
                            required
                            value={fields[item]?.fvalue || ''}
                            onChange={(e) => handleOnchange(item, e.target.value)}
                            onClick={(e) => handleOnchange(item, e.target.value, 'click')}
                            style={{ background: 'transparent', textAlign: 'left' }}
                            id={`report_id_${key}`}
                          />

                          {fields[item].type === 'dropdown' && <span className="select_arrow input_icon sicon" />}
                          <span className="inputbar" />
                          <label htmlFor={`report_id_${key}`} className="input_label font12 fw500 color777">
                            {fields[item].heading}
                            <span className="colorF45">*</span>
                          </label>
                          {fields[item].type === 'dropdown' &&
                            display.name === 'city' &&
                            fields[item].name === 'city' &&
                            fields[item].fvalue && (
                              <div className="input__dropdown" style={{ display: display.disp ? 'block' : 'none' }}>
                                <ul className="input__droplist">
                                  {cityFilter &&
                                    Object.keys(cityFilter).length > 0 &&
                                    Object.keys(cityFilter).map((each, idx) => (
                                      <li className="input__dropitem" key={idx}>
                                        <div
                                          onClick={() => handleDropDownClick(item, each)}
                                          aria-label="user_report_cityFilter_click"
                                          tabIndex={0}
                                          role="button"
                                          onKeyDown={() => {}}
                                          className="input__dropanchor  font12 fw400 color111"
                                        >
                                          {each}
                                        </div>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            )}
                          {fields[item].type === 'dropdown' &&
                            display.name === 'compType' &&
                            fields[item].name === 'compType' && (
                              <div className="input__dropdown" style={{ display: display.disp ? 'block' : 'none' }}>
                                <ul className="input__droplist">
                                  {complaintList[selectedItem]?.subIssue.map((x, idx) => (
                                    <li className="input__dropitem" key={idx}>
                                      <div
                                        aria-label="user_report_subIssue_click"
                                        tabIndex={0}
                                        role="button"
                                        onKeyDown={() => {}}
                                        onClick={() => handleDropDownClick(item, x)}
                                        className="input__dropanchor  font12 fw400 color111"
                                      >
                                        {x}
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          {fields[item].type === 'dropdown' &&
                            display.name === 'compname' &&
                            fields[item].name === 'compname' &&
                            fields[item].fvalue && (
                              <div className="input__dropdown" style={{ display: display.disp ? 'block' : 'none' }}>
                                <ul className="input__droplist">
                                  {businessDataRes &&
                                    businessDataRes?.data &&
                                    businessDataRes?.data?.length > 0 &&
                                    businessDataRes?.data?.map((each, idx) => (
                                      <li className="input__dropitem" key={idx}>
                                        <div
                                          onClick={() => handleDropDownClick(item, each.companyName, each)}
                                          aria-label="user_report_compname_click"
                                          tabIndex={0}
                                          role="button"
                                          onKeyDown={() => {}}
                                          className="input__dropanchor  font12 fw400 color111"
                                        >
                                          {each.companyName} , {each?.location}
                                        </div>
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            )}
                        </div>
                      </div>
                      {errorView(item, fields[item]?.fvalue)}
                    </>
                  )}
                </React.Fragment>
              ))}

            <div className={`${styles.input__textarea__group} form_group_box mt-25`} style={{ height: '110px' }}>
              <div className={` form_group`}>
                <textarea
                  value={fields?.comment?.fvalue || ''}
                  className={`${styles.input__textarea} input font12 fw500 color111 pl-10 pr-45 pt-10`}
                  onChange={(e) => handleOnchange('comment', e.target.value)}
                  required
                  style={{ background: 'transparent', textAlign: 'left' }}
                  id="report_comment"
                />
                <span className="inputbar" />
                <label
                  htmlFor="report_comment"
                  className={`${styles.input__textarea__lable}  input_label font12 fw500 color777`}
                >
                  {fields?.comment?.heading}
                  <span className="colorF45">*</span>
                </label>
              </div>
            </div>
            {!CheckingValidComment(fields?.comment?.fvalue) && fields?.comment?.fvalue?.length > 3 && (
              <div className="font12 fw500 colorEC4 ml-2 mt-6 mb-6">Please avoid special characters.</div>
            )}
            <div className={`${styles.Upload__Group} mt-25`}>
              <div className={`${styles.Upload__Box} pt-10 pb-10`}>
                <div className={`${styles.Upload__Text} mt-4 font12 fw400 color777 pb-10`}>
                  {complaintList[selectedItem]?.issue === 'Complaint against vendor'
                    ? 'Upload payment/communication/other proof.'
                    : 'Upload relevant attachment'}
                </div>
                <div className={`${styles1.UploadBox}`}>
                  <ul className={`${styles1.UploadList}`}>
                    {fileData &&
                      fileData.length > 0 &&
                      fileData.map((each, idx) => (
                        <li className={`${styles1.UploadItem}`}>
                          <div className={`${styles1.UploadImage}`} key={idx}>
                            <img className={`${styles1.UploadImg}`} src={`${each.url}`} alt="" />
                          </div>
                          <div className={`${styles1.UploadText} font12 fw400 color111 pl-12 pr-12`}>{each.name}</div>
                          <div
                            aria-label="report_file_delete"
                            tabIndex={0}
                            role="button"
                            onKeyDown={() => {}}
                            className={`${styles1.UploadAnchor} font12 fw500 color007`}
                            onClick={() => handleFileDelete(idx)}
                          >
                            Delete
                          </div>
                        </li>
                      ))}
                  </ul>

                  <label
                    htmlFor="report_btn"
                    className={
                      fileData && fileData.length >= 5
                        ? `${styles1.UploadButton} ${styles1.Disabled}`
                        : `${styles1.UploadButton} ${styles1.bluefill_animate} mt-12`
                    }
                  >
                    <input
                      className={`${styles1.UploadButton__Input} `}
                      type="file"
                      accept="image/*"
                      onChange={handleFileUpload}
                      onClick={(e) => {
                        e.target.value = null;
                      }}
                      name=""
                      disabled={fileData && fileData.length >= 5}
                      id="report_btn"
                    />
                    <div className={`${styles1.UploadButton__Icon} csicon mr-6`} />
                    <div className="font14 fw500 colorFFF" disabled={fileData && fileData.length === 5}>
                      Upload
                    </div>
                  </label>
                </div>
              </div>
            </div>
            {fileData && fileData.length === 5 && (
              <div className={`${styles.Button__Box} pt-20 mt-20`}>{errorView('upload', fileData.length)}</div>
            )}
            <div className={`${styles.Button__Box} pt-20 mt-20`}>
              <button
                type="button"
                className={`${
                  disable || haveSubmitted ? styles.Upload__BtnText : `${styles.Button} bluefill_animate`
                } font12 fw400 colorFFF mt-20`}
                onClick={handleSubmitClick}
                disabled={disable || haveSubmitted}
              >
                Submit
              </button>
            </div>
            {disable && (
              <div className="font12 fw500 colorEC4 text-center mt-4">Please fill the mandatory fields *</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

UserForm.propTypes = {
  selectedItem: PropTypes.string,
  fields: PropTypes.object,
  setFields: PropTypes.func,
  fileData: PropTypes.array,
  setFileData: PropTypes.func,
  handleSubmitClick: PropTypes.func,
  cityList: PropTypes.object,
  haveSubmitted: PropTypes.bool,
};

export default UserForm;
